import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { workflowService, ProgramStatusAuditLog } from '@/services/features/WorkflowService';

export const useProgramStatusAuditLog = (programStatusId: number | null) => {
  const [programStatusAuditLogs, setProgramStatusAuditLogs] = useState<ProgramStatusAuditLog[]>([]);
  const [auditLogsLoading, setAuditLogsLoading] = useState(false);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!programStatusId || !hasuraToken) return;

      setAuditLogsLoading(true);
      try {
        const result = await workflowService.getProgramStatusAuditLog(hasuraToken, programStatusId);
        setProgramStatusAuditLogs(result.logs);
      } catch (error) {
        console.error('Error fetching program status audit logs:', error);
        setProgramStatusAuditLogs([]);
      } finally {
        setAuditLogsLoading(false);
      }
    };

    fetchAuditLogs();
  }, [programStatusId, hasuraToken]);

  return {
    programStatusAuditLogs,
    auditLogsLoading,
  };
};
